import { ChatProvider } from '@/contexts';
import { ChatPage } from '@/pages';
import { Footer } from '@/components/layout/Footer';
import { CookieConsentProvider } from '@/components/cookie/CookieConsentProvider';
import { GTMProvider } from './components/retargeting/GTMprovider.tsx';
import { FacebookPixelProvider } from '@/components/retargeting/FacebookPixelProvider';
import { useChat } from '@/hooks';
import './styles/globals.css';

function AppContent() {
    const { messages, selectedAssistant } = useChat();

    const handleCookieConsent = (consented: boolean) => {
        console.log('Cookie consent changed:', consented);

        if (consented) {
            console.log('Enabling Meta Pixel tracking...');
            // Dispatch custom event to trigger pixel loading
            window.dispatchEvent(new Event('cookieConsentAccepted'));
        } else {
            console.log('Meta Pixel tracking disabled - cookies declined');
        }
    };

    const showFooter = !selectedAssistant;

    return (
        <FacebookPixelProvider>
            <GTMProvider>
                <CookieConsentProvider
                    assistantName="GPTforMe"
                    onConsentChange={handleCookieConsent}
                >
                    {(hasConsented, checkConsent, showBanner) => (
                        <div className="min-h-screen">
                            <ChatPage showBanner={showBanner} />
                            {showFooter && <Footer />}
                        </div>
                    )}
                </CookieConsentProvider>
            </GTMProvider>
        </FacebookPixelProvider>
    );
}

function App() {
    return (
        <ChatProvider>
            <AppContent />
        </ChatProvider>
    );
}

export default App;